import { gql } from '@apollo/client'
import { CustomerFragments } from './queries'

export const CREATE_CUSTOMER_MUTATION = gql`
  mutation CreateCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      customer {
        ...CustomerInfo
      }
    }
  }
  ${CustomerFragments.customerInfo}
`

export const PATCH_CUSTOMER_MUTATION = gql`
  mutation PatchCustomer($id: ID!, $input: PatchCustomerInput!) {
    patchCustomer(id: $id, input: $input) {
      customer {
        ...CustomerInfo
      }
    }
  }
  ${CustomerFragments.customerInfo}
`
